import { X } from 'lucide-react';
import React from 'react';
import Button from '../../../../../components/ComponentsV1/Button';

const ParentCategoryDetailsSheet = ({
  showParentCategory,
  showParentCategoryDetails,
  parentCategoryDetails,
  handleSetPLCClick = () => {},
}) => {
  return (
    <div
      className='tw-absolute tw-bottom-0 tw-w-full tw-z-50'
      style={{
        height: showParentCategory ? 'auto' : 0,
        transform: showParentCategory ? 'translateY(0)' : 'translateY(100%)',
        opacity: showParentCategory ? 1 : 0,
        pointerEvents: showParentCategory ? 'auto' : 'none',
        visibility: showParentCategory ? 'visible' : 'hidden',
        transition:
          'transform 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.25s ease, visibility 0s linear ' +
          (showParentCategory ? '0s' : '0.35s'),
      }}
    >
      <div className='tw-w-full tw-flex tw-items-center tw-justify-center tw-mb-4'>
        <X
          className='tw-text-grey-800 tw-rounded-full tw-bg-grey-200 tw-p-2 tw-cursor-pointer'
          size={30}
          onClick={showParentCategoryDetails}
        />
      </div>
      <div className=' tw-rounded-t-3xl tw-p-6 tw-border-solid tw-border-b-0 tw-border-x-0 tw-border-grey-200 tw-bg-grey-100'>
        <div className='tw-font-medium tw-text-[1.5rem] tw-mb-4'>
          Parent Category details
        </div>
        <div className='tw-flex tw-flex-col tw-border tw-border-solid tw-rounded-lg tw-border-grey-200 tw-bg-white'>
          {Object.entries(parentCategoryDetails || {}).map(([key, value]) => {
            let displayValue = value;
            if (key === 'return_policy_image') {
              displayValue = value ? value?.title + ' ' + value?.url : '';
            }
            return (
              <div
                key={key}
                className='tw-flex tw-items-start tw-justify-between tw-p-3 tw-w-full'
              >
                <span className='tw-text-[1.4rem] tw-font-medium tw-text-zinc-600 tw-capitalize tw-w-1/3'>
                  {key?.replace(/_/g, ' ')}
                </span>
                <span className='tw-text-[1.4rem] tw-w-2/3 tw-leading-normal tw-font-medium tw-text-zinc-500 tw-whitespace-normal'>
                  {String(displayValue || '-')}
                </span>
              </div>
            );
          })}
        </div>
        <div className='tw-w-full tw-flex tw-justify-end'>
          <Button
            title={'Set as Product level config'}
            className='tw-mt-6'
            onClick={handleSetPLCClick}
          />
        </div>
      </div>
    </div>
  );
};

export default ParentCategoryDetailsSheet;
